













































































































































































































































import _ from "lodash";
import rest from "@/rest";
import { RestResponse } from "@/interfaces/RestResponse";
import { Component, Vue } from "vue-property-decorator";
import { vuex } from "@/store";
// import wretch, { WretcherError } from "wretch";
// Interfaces
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ExSubject } from "@/interfaces/ExSubject";
import { ExBundleGroupVM, ExBundleVM } from '../interfaces/ExBundleGroupVM';
import { ParamGetExercises } from "@/interfaces/ParamGetExercises";
import { QrMediaLinkVM } from "@/interfaces/QrMediaLinkVM";
// Components
import FileDrop from "@/components/Shared/FileDrop.vue";
import TusFileDrop from "@/components/Shared/TusFileDrop.vue";
import UploadButton from "@/components/Shared/UploadButton.vue";
import UploadArchiveMenuButton from "@/components/UploadArchiveMenuButton.vue";
import EditScormDetailsDlg from "@/components/ExerciseManager/EditScormDetailsDlg.vue";
import VueQrcode from "@chenfengyuan/vue-qrcode"; // https://github.com/fengyuanchen/vue-qrcode
import { namespace } from "vuex-class";
import { ExCategory1 } from "@/interfaces/ExCategory1";
import { ExCategory2 } from "@/interfaces/ExCategory2";
import { CategorySelectListsVm } from "@/interfaces/CategorySelectListsVm";
import { List } from "linq-collections";
import { FileDetailsVm } from "@/interfaces/FileDetailsVm";
import { signalrEventBus } from "@/main";
import BundleSelection from "@/components/ContentCreator/BundleSelection.vue";
// import de from 'vuetify/src/locale/de';

const auth = namespace("auth");
const ux = namespace("ux");
const globals = namespace("globals");

@Component({
  components: {
    FileDrop,
    TusFileDrop,
    UploadButton,
    UploadArchiveMenuButton,
    EditScormDetailsDlg,
    BundleSelection,
    qrcode: VueQrcode
  }
})
export default class ContentManager extends Vue {
  @auth.Getter isAdmin: any;
  @globals.Getter selectedBundle: any;

  showDeleteFileDialog: boolean = false;
  // showDeleteBundleDialog = false;
  showGuidDialog: boolean = false;
  showArchiveLog: boolean = false;
  showMediaLinkDialog: boolean = false;

  directorySize: number = 0;
  fileUploadParam: ParamDictionary = { dictionary: {}};
  fileListParam: ParamDictionary = { dictionary: {}};
  fileDownloadParam: ParamDictionary = { dictionary: {}};
  bundleFileList: FileDetailsVm[] | null = null;
  selectedFile: FileDetailsVm | null = null;
  newGuid: string | null = null;
  qrMediaLink: QrMediaLinkVM | null = null;
  fileImportList: string[] = [];
  fileImportBusy = false;
  fileUploadList: string[] = [];
  fileUploadBusy = false;
  zipArchiveCreationBusy = false;
  bundleZipCreationBusy = false;
  scormZipCreationBusy = false;
  updateBundlesBusy = false;
  archiveLog = "";
  guid: string = "";

  $refs!: {
    detailsPanel: HTMLFormElement;
    qrcodeCanvas: HTMLCanvasElement;
    bundleSelection: BundleSelection;
  };

  async mounted() {
    this.getDirectorySize();
  }

  created() {
    // SignalR event listener
    signalrEventBus.$on('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('zipArchiveCreationFinished', this.zipArchiveCreationFinished);
    signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  // SignalR events
  zipArchiveCreationFinished(response: any) {
    console.log("ContentManager > Zip archive creation finished:", response.zipFilePath + " " + response.message);
    if (response.status == "SUC") {
      this.$globalHelper.downloadFile(response.zipFilePath);
    } else {
    }

    // this.$emit('content:ZipArchiveCreationFinished');
    this.zipArchiveCreationBusy = false;
    this.bundleZipCreationBusy = false;
    this.scormZipCreationBusy = false;
  }

  async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
    if (this.guid !== response.id) return;
    console.log("ContentManager > Background task event:", response);
    if (response.status == "INF") {
      vuex.ux.SB_SUCCESS({
        message: response.message,
        timeout: 60000
      });
      return;
    }
    if (response.status == "SUC") {
      vuex.ux.SB_SUCCESS({
        message: response.message,
        timeout: 5000
      });
    }
    if (response.status == "ERR") {
      vuex.ux.SB_FAILURE({
        message: response.message,
        timeout: 0
      });
    }

    await this.updateBundles();
    this.updateBundlesBusy = false;
  }

  async updateView() {
    await this.updateBundles();
    this.getBundleFiles();
  }

  async updateBundles() {
    await this.$refs.bundleSelection.updateView();
  }

  async getBundleFiles() {
    if (this.selectedBundle == null)
      return;

    this.bundleFileList = null;
    this.fileListParam.dictionary!["BundleId"] = this.selectedBundle.id.toString();
    this.fileListParam.dictionary!["LocalPath"] = this.selectedBundle.localPath!;
    this.fileListParam.dictionary!["Type"] = "";
    this.bundleFileList = await rest.url("contentManager/getBundleFiles").post(this.fileListParam);
  }

  async onFilesUploaded() {
    await this.updateBundles();
    await this.getBundleFiles();
  }

  async showExerciseBundle(bundle: ExBundleVM) {
    await this.getBundleFiles();
  }

  async onBundleOrArchiveFileUploaded(response: any) {
    if (!response.success) {
      this.$store.commit("ux/SB_FAILURE", {
        message: response.message,
        timeout: 0
      });
      return;
    }

    // Add file to list and start import on server
    this.fileImportList.push(response.fileName);
    this.processFileImportList();
  }

  async processFileImportList() {
    if (this.fileImportList.length == 0 || this.fileImportBusy)
      return;

    this.fileImportBusy = true;
    let nextFile = this.fileImportList.pop();
    this.fileUploadParam.dictionary!["FileName"] = nextFile!;
    await rest.url("contentManager/importExerciseExcelOrZipArchiveFile").post(this.fileUploadParam)
    .then(async (response) => {
      if (!response) {
        vuex.globals.setBundle(null);
        await this.updateBundles();
        return;
      }

      if (nextFile?.endsWith(".xlsx")) {
        vuex.globals.setBundle(<ExBundleVM> { guid: response });
        await this.updateBundles();
        return;
      }

      this.archiveLog += "<br<br>" + response;
      this.showArchiveLog = true;
      await this.updateBundles();
    })
    .catch(err => {
    })
    .finally(() => {
      this.fileImportBusy = false;
      this.processFileImportList();
    });
  }

  onFileUploadedToTempDir(response: any) {
    if (!response.success) {
      this.$store.commit("ux/SB_FAILURE", {
        message: response.message,
        timeout: 0
      });
      return;
    }

    // Add file to list and start import on server
    this.fileUploadList.push(response.fileName);
    this.processFileUploadList();
  }

  async processFileUploadList() {
    if (this.fileUploadList.length == 0 || this.fileUploadBusy)
      return;

    this.fileUploadBusy = true;
    let nextFile = this.fileUploadList.pop();

    this.fileUploadParam.dictionary!["BundleId"] = this.selectedBundle!.id.toString();
    this.fileUploadParam.dictionary!["ExerciseId"] = "0"; // Not used in this case
    this.fileUploadParam.dictionary!["UpdateBundle"] = "true"; // Update bundle with uploaded file
    this.fileUploadParam.dictionary!["OnlyScormZip"] = "false"; // All kind of zip files are accepted
    this.fileUploadParam.dictionary!["LocalPath"] = this.selectedBundle!.localPath!; // Shared Resource and Temp dir didn't have a bundle ID. Use LocalPath instead.
    this.fileUploadParam.dictionary!["FileName"] = nextFile!;
    await rest.url("contentManager/moveFileToLocalDir").post(this.fileUploadParam)
    .then(async (response) => {
      if (!response) {
        return;
      }
      // select category of uploaded Excel file
      vuex.globals.setBundle(<ExBundleVM> { guid: response });
      await this.updateBundles();
    })
    .catch(err => {
    })
    .finally(() => {
      this.fileUploadBusy = false;
      this.processFileUploadList();
    });

    this.getBundleFiles();
  }

  async copyToClipboard() {
    await navigator.clipboard.writeText(this.newGuid ?? "?");
    this.$store.commit("ux/SB_SUCCESS", {
      message: (this.newGuid ?? "?") + " in Zwischenablage kopiert",
      timeout: 2000
    });
  }

  onReady(canvas) {
    const context = canvas.getContext('2d');
    const image = new Image();

    image.src = 'qr-icon.png';
    image.crossOrigin = 'anonymous';
    image.onload = () => {
      const coverage = 0.15;
      const width = Math.round(canvas.width * coverage);
      const x = (canvas.width - width) / 2;

      this.drawImage(context, image, x, x, width, width);
    };
  }

  drawImage(context, image, x, y, width, height, radius = 4) {
    context.shadowOffsetX = 0;
    context.shadowOffsetY = 2;
    context.shadowBlur = 4;
    context.shadowColor = '#00000040';
    context.lineWidth = 8;
    context.beginPath();
    context.moveTo(x + radius, y);
    context.arcTo(x + width, y, x + width, y + height, radius);
    context.arcTo(x + width, y + height, x, y + height, radius);
    context.arcTo(x, y + height, x, y, radius);
    context.arcTo(x, y, x + width, y, radius);
    context.closePath();
    context.strokeStyle = '#fff';
    context.stroke();
    context.clip();
    context.fillStyle = '#fff';
    context.fillRect(x, x, width, height);
    context.drawImage(image, x, x, width, height);
  }

  async getDirectorySize() {
    // let pathParams = { dictionary: { LocalPath: this.selectedBundle.localPath!} };
    let pathParams = { dictionary: { LocalPath: ""} };
    this.directorySize = await rest.url("contentManager/getDirectorySize").post(pathParams);
  }

  get dirSize() {
    return this.sizeFormatted(this.directorySize);
  }

  sizeFormatted(size: number): string {
    if (!+size) return '0 Bytes'

    const k = 1024;
    const dm = 2;
    const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

    const i = Math.floor(Math.log(size) / Math.log(k))

    return `${parseFloat((size / Math.pow(k, i)).toFixed(dm)).toLocaleString()} ${sizes[i]}`
  }

  get fileCount() {
    if (!this.bundleFileList)
      return "";

    return ` (${this.bundleFileList.length})`
  }

  async downloadFile(fileInfo: FileDetailsVm) {
    if (!fileInfo)
      return;

    if (fileInfo.isDirectory) {
      await this.createScormZipFile(fileInfo);
      return;
    }

    // let fileName = fileInfo?.name ?? ""
    // this.$globalHelper.download(`api/resource/${this.selectedBundle!.localPath ?? ""}/${fileName}`, fileName);
    this.$globalHelper.download(fileInfo.filePath!, fileInfo.name!);

    // this.fileDownloadParam.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();
    // this.fileDownloadParam.dictionary!["LocalPath"] = this.selectedBundle!.localPath ?? "";
    // this.fileDownloadParam.dictionary!["FileName"] = fileName;
    // let token = window.localStorage.getItem("digiClassAuth");
    // wretch("/api/contentManager/downloadFileFromBundle")
    // .auth(`Bearer ${ token }`)
    // .post(this.fileDownloadParam)
    // .blob(data => {
    //   // const blob = new Blob([data], { type: 'application/pdf' });
    //   const blob = new Blob([data]);
    //   const link = document.createElement('a');
    //   link.href = URL.createObjectURL(blob);
    //   link.download = fileName;
    //   link.click();
    //   URL.revokeObjectURL(link.href);
    // })
    // .catch(err => {
    //   let apiError: RestResponse = JSON.parse(err.text);
    //   this.$store.commit("ux/SB_FAILURE", {
    //     message: `Server Error - ${apiError.description}`,
    //     timeout: 0
    //   });
    // });
  }

  async readMediaLink(fileInfo: FileDetailsVm) {
    this.selectedFile = fileInfo;
    // this.fileDownloadParam.dictionary!["MediaLinkId"] =  this.selectedBundle!.id.toString();
    this.fileDownloadParam.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();
    this.fileDownloadParam.dictionary!["LocalPath"] = this.selectedBundle!.localPath ?? "";
    this.fileDownloadParam.dictionary!["FileName"] = fileInfo?.name ?? "";
    this.fileDownloadParam.dictionary!["YouTubePath"] = this.qrMediaLink?.youTubePath ?? "";

    this.qrMediaLink = await rest.url("contentManager/readMediaLink").post(this.fileDownloadParam);

    this.showMediaLinkDialog = true;
    // Create qrcode logo
    await this.$globalHelper.delay(100);
    this.onReady((this.$refs.qrcodeCanvas as any).$el);
  }

  async writeMediaLink() {
    await rest.url("contentManager/writeMediaLink").post(this.qrMediaLink);
    this.showMediaLinkDialog = false;
  }

  // async downloadBundleZipFile() {
  //   this.fileDownloadParam.dictionary = {};
  //   this.fileDownloadParam.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();

  //   let token = window.localStorage.getItem("digiClassAuth");
  //   wretch("/api/contentManager/downloadBundleZip")
  //   .auth(`Bearer ${ token }`)
  //   .post(this.fileDownloadParam)
  //   .blob(data => {
  //     // const blob = new Blob([data], { type: 'application/pdf' });
  //     const blob = new Blob([data]);
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${ this.selectedBundle!.category1 }-${ this.selectedBundle!.category2 }-${ this.selectedBundle!.name }.zip`;
  //     link.click();
  //     URL.revokeObjectURL(link.href);
  //   })
  //   .catch(err => {
  //     let apiError: RestResponse = JSON.parse(err.text);
  //     this.$store.commit("ux/SB_FAILURE", {
  //       message: `Server Error - ${apiError.description}`,
  //       timeout: 0
  //     });
  //   });
  // }

  async createScormZipFile(fileInfo: FileDetailsVm) {
    this.scormZipCreationBusy = true;

    await this.$l3rnOnlineHub.ensureConnection();

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();
    params.dictionary!["DirName"] = fileInfo?.name ?? "";

    await rest.url("contentManager/createScormZipFile")
      .post(params)
      .then((guid) => {
        this.guid = guid;
      });
  }

  async createBundleZipFile() {
    this.bundleZipCreationBusy = true;

    await this.$l3rnOnlineHub.ensureConnection();

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] =  this.selectedBundle!.id.toString();

    await rest.url("contentManager/createBundleZipFile")
      .post(params)
      .then((guid) => {
        this.guid = guid;
      });
  }

  // async downloadExerciseZipFile() {
  //   this.fileDownloadParam.dictionary = {};
  //   this.fileDownloadParam.dictionary!["Category1"] =  this.selectedCat1Item!.name ?? "";
  //   this.fileDownloadParam.dictionary!["Category2"] =  this.selectedCat2Item!.name ?? "";

  //   let token = window.localStorage.getItem("digiClassAuth");
  //   wretch("/api/contentManager/downloadCategory3BundlesAsZip")
  //   .auth(`Bearer ${ token }`)
  //   .post(this.fileDownloadParam)
  //   .blob(data => {
  //     // const blob = new Blob([data], { type: 'application/pdf' });
  //     const blob = new Blob([data]);
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //     link.download = `${ this.selectedCat1Item!.name }-${ this.selectedCat2Item!.name }-all.zip`;
  //     link.click();
  //     URL.revokeObjectURL(link.href);
  //   })
  //   .catch(err => {
  //     let apiError: RestResponse = JSON.parse(err.text);
  //     this.$store.commit("ux/SB_FAILURE", {
  //       message: `Server Error - ${apiError.description}`,
  //       timeout: 0
  //     });
  //   });
  // }

  async onCreateCategory2Archive(categories: any) {
    this.zipArchiveCreationBusy = true;
  }

  async deleteFile () {
    if (!this.selectedBundle || !this.selectedFile)
      return;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["BundleId"] =  this.selectedBundle.id.toString();
    params.dictionary!["LocalPath"] = this.selectedBundle.localPath ?? "";
    params.dictionary!["RelativePath"] = "";
    params.dictionary!["FileName"] = this.selectedFile.name ?? "";
    params.dictionary!["IsDirectory"] = this.selectedFile.isDirectory.toString();

    await rest.url("contentManager/deleteFileOrDirectoryFromBundle").post(params);
    this.showDeleteFileDialog = false;
    this.getBundleFiles();
  }

  async generateGuid() {
    this.newGuid = await rest.url("contentManager/getNewGuid").get();
    this.showGuidDialog = true;
  }

  // Reads Exercises directory on server and imports all bundle information's
  async updateBundlesOnServer() {
    // ensure signalr connection for progress updates
    this.updateBundlesBusy = true;
    await this.$l3rnOnlineHub.ensureConnection();

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;

    this.guid = await rest.url("contentManager/updateExBundles").post(params);
    // await this.updateBundles();
  }

  // use $vuetify.breakpoint.xs to determine current breakpoint instead of checking height of element
  isDetailsCardVisible(): boolean {
    // const style = getComputedStyle(this.$refs.detailsPanel);
    // let val = style.display !== 'none';
    // https://davidwalsh.name/offsetheight-visibility
    let height = this.$refs.detailsPanel.offsetHeight;
    // alert(height);
    let visible = height !== 0;
    return visible;
  }

  // replace with vuex variant
  get backgroundColor() {
    let currentThemeName = this.$vuetify.theme.dark ? 'dark' : 'light';
    return this.$vuetify.theme.themes[currentThemeName].background;
  }
}
